/*
  getContrastColor.js
*/

/**
 * Returns contrast color for a given hex string.
 */
export default function getContrastColor(hexStr) {
  let luma = 0;
  if (hexStr.startsWith('#')) {
    let r = 0;
    let g = 0;
    let b = 0;
    if (hexStr.length === 7) {
      r = parseInt(hexStr.slice(1, 3), 16);
      g = parseInt(hexStr.slice(3, 5), 16);
      b = parseInt(hexStr.slice(5, 7), 16);
    } else if (hexStr.length === 3) {
      r = parseInt(hexStr.slice(1, 2), 16);
      g = parseInt(hexStr.slice(2, 3), 16);
      b = parseInt(hexStr.slice(3, 4), 16);
      r = (r << 4) + r;
      g = (g << 4) + g;
      b = (b << 4) + b;
    }
    luma = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
  }
  return luma >= 165 ? '#000' : '#FFF';
}
